import { render, staticRenderFns } from "./loginCode.vue?vue&type=template&id=5518f9b2&scoped=true"
import script from "./loginCode.vue?vue&type=script&lang=js"
export * from "./loginCode.vue?vue&type=script&lang=js"
import style0 from "./loginCode.vue?vue&type=style&index=0&id=5518f9b2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5518f9b2",
  null
  
)

export default component.exports